var runSizeOnce = false;
$(function() {
  $('select[name="id"]').after(
    '<input name="id" class="no-js product-select" id="amazix" type="hidden" />');
  $('select[name="id"]').remove();
  if (typeof vproducts === 'undefined' || !vproducts) {
    $('div.available--color').remove();
    $('input[name="id"]').val(vproduct.variants[0].id);
    sizeClick();
  } else {
    setupVariants();
  }

  $('body').on('change', "select[data-id='Size']", function() {
    sizeClick();
  })
});

function getHandleSharedBit() { //this depends on the first two variants having the correct shared bits..rather arbitrary
  handle_one = vproducts[0].handle;
  handle_two = vproducts[1].handle;

  var leng = Math.min(handle_one.length, handle_two.length);
  var idx = 1;
  while (leng-- > 0) {
    if (handle_one.substr(0, idx) != handle_two.substr(0, idx))
      return handle_one.substr(0, idx - 1);
    idx++;
  }
  console.log(handle_one);

  return handle_one; //you dont get here unless they match exactly or somethings wrong
}

function setupVariants() {
  var handleSharedBit = getHandleSharedBit();
  /*vproduct.handle;
    if (handleSharedBit.lastIndexOf('-') > 0)
      handleSharedBit = handleSharedBit.substr(0,handleSharedBit.lastIndexOf('-')+1);*/ //not fool proof but how the data is set up

  var swatchContainer = $('.available--color-items');
  var masterClone = $(swatchContainer).find('.available--color-item').first()
    .clone().removeClass('item__selected');
  $(swatchContainer).find('.available--color-item').remove();

  $(vproducts).each(function() {
    var prod = this;
    var thisClone = $(masterClone).clone();
    optionValue = prod.handle; //.replace(handleSharedBit,'');

    thisClone.find('img').attr('src', prod.featured_image);
    thisClone.find('img').attr('alt', optionValue);
    thisClone.attr('data-option', optionValue);
    thisClone.attr('data-id', prod.id);
    thisClone.addClass('color-' + optionValue);
    thisClone.find('.color-tool').addClass('color-' + optionValue);
    thisClone.find('.color-name').html(optionValue);
    thisClone.attr('tabindex', "0");

    $(swatchContainer).append(thisClone);
  });

  if (!vproducts || $(vproducts).length < 2)
    $('div.available--color-text').html('');
  else
    $('div.available--color-text').html('Available in ' + $(vproducts).length.toString() +
      ' Colors');

  $('.available--color-item').click(function() {
    optionClick($(this));
  });

  $('.available--color-item').on('keydown', function(e) {
    var key = slate.a11y.getKeyValue(e);
    if (slate.a11y.isEnterKey(key) || slate.a11y.isSpaceKey(key)) {
      e.preventDefault();
      optionClick($(this));
    }
  });

  var thisColorLandedOn = vproduct.id;
  $('.available--color-item[data-id="' + thisColorLandedOn + '"]').click();
}

function updateURLParameter(url, param, paramVal) {
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";
  if (additionalURL) {
    tempArray = additionalURL.split("&");
    for (var i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split('=')[0] != param) {
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  }

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
}

function optionClick(option) {
  var $colorItems = $('.available--color-item');
  $colorItems.removeClass('item__selected').attr('aria-checked', 'false');
  $(option).addClass('item__selected');
  $(option).attr('aria-checked', 'true');
  var optValue = $(option).attr('data-option');
  var optId = $(option).attr('data-id');
  var thisProduct = $(vproducts).filter(function() {
    return this.id == optId
  }).first();

  if (!thisProduct)
    return;
  else {
    thisProduct = thisProduct[0];
  }

  $('h1.header__3').html(thisProduct.title);
  $('span.item-details-sku').text(' Item #: '+thisProduct.variants[0].sku);
  $('.product__desc .rte').html( thisProduct.description);
  $('input[name="id"]').val(thisProduct.variants[0].id);

  if(thisProduct.variants[0]) {
    updatePrice(thisProduct.variants[0]);
  }
  /*  if (size.available) {
      $(thisClone).removeClass('oos');
    } else {
      $(thisClone).addClass('oos');
    }
    */

  setupVariantImages(thisProduct);
  if(!runSizeOnce) {
    sizeClick();
  }
}

function sizeClick() {
  const color = $(".available--color-item.item__selected");
  const optId = color.attr('data-id');
  let thisProduct = vproducts ? $(vproducts).filter(function() {
    return this.id == optId
  }).first() : vproduct;

  if (!thisProduct)
    return;
  else {
    thisProduct = vproducts ? thisProduct[0] : vproduct;
  }

  const sizeSelector = $("select[data-id='Size']");
  let variant = null;
  if(sizeSelector.length > 0) {
    variant = thisProduct.variants.find(function(variant) {
      return variant.title == sizeSelector[0].value
    })
  }

  $('h1.header__3').html(thisProduct.title);
  $('.product__desc .rte').html( thisProduct.description);
  if(variant) {
    updatePrice(variant);
  }
}

function updatePrice(variant) {
  $('span.item-details-sku').text(' Item #: '+ variant.sku);
  $('input[name="id"]').val(variant.id);

  // Clear price
  $('span.product-price').replaceWith('');
  const priceContainer = $(".price_add_wrapper .price");
  let priceHTML = `<span class="product-price ">$${(variant.price / 100.0).toFixed(0)}</span>`;

  if(variant.compare_at_price) {
    // Add price and compare at price
    priceHTML = `<span class="compare-product-item product-price">$${(variant.compare_at_price / 100.0).toFixed(0)}</span>
      <span class="product-price sale-red-text">$${(variant.price / 100.0).toFixed(0)}</span>
    `;
  }
  priceContainer.prepend(priceHTML);
}

function setupVariantImages(thisVariant) {
  var slickSlideDummy2 = $('.product__gallery .slick-slider .slick-slide').first()
    .clone();
  var slickSlideDummy = $(
    '<div role="group">'+
      '<div class="product__img--cover">'+
        '<img class="js" src="" alt="">'+
        // '<a class="no-js" href=""><img src="" alt=""></a>'+
      '</div>'+
      '<div class="hand-select-icon">'+
        '<img src="'+slickSlideDummy2.find('.hand-select-icon').children('img').first().attr('src')+'" alt="Touch to zoom in on image">'+
        '<p style="font-weight: bold; font-size: 14px;margin-top: 0;margin-bottom: 0.2rem;">Tap to Zoom</p>'+
      '</div>'+
    '</div>'
  );
  while ($('.product__gallery .pslider_big.slick-slider .slick-slide').length)
    $('.product__gallery .pslider_big.slick-slider').slick('slickRemove', 0);

  $(thisVariant.images).each(function() {
    var thisNewSlide = slickSlideDummy.clone();
    var thisNewSlideImg = thisNewSlide.find('.product__img--cover');
    $(thisNewSlideImg).find('img').attr('src', this.toString());
    $(thisNewSlideImg).find('a').attr('href', this.toString());
    var img = this.toString();
    img = img.substr(img.indexOf('products/') + 9);
    img = img.substr(0, img.indexOf('.png'));
    var imgid = '';
    $(thisNewSlide).find('img.js').each(function() {
      if ((typeof $(this).attr('src') !== 'undefined' && $(this).attr(
          'src').indexOf(img) > -1) || (typeof $(this).attr('data-lazy') !==
          'undefined' && $(this).attr('data-lazy').indexOf(img) > -1)) {
        imgid = $(this).closest('li.gallery__image').attr(
          'data-image-id');
        if (typeof $(this).attr('src') == 'undefined')
          $(this).attr('src', $(this).attr('data-lazy'));
      }
    });
    $(thisNewSlideImg).find('img').attr('data-image-id', imgid);
    if (typeof $(thisNewSlide)[0] !== 'undefined')
      $('.product__gallery .pslider_big.slick-slider').slick('slickAdd', $(
        thisNewSlide)[0].outerHTML);
  });
  // $('div.slick-track .slick-slide img').unbind();
  // $('div.slick-track .slick-slide img').click(function(evt) {
  //   evt.preventDefault();
  //   var imageId = $(this).data('image-id');
  //   console.log('click');
  //   setActiveThumbnail(imageId);
  //   switchProductImage(imageId);
  // });

  $('div.slick-list.draggable').height('100%');
}


const productImageContainers = '.product__photo-container-product-template';
const productThumbContainers = '.product-single__thumbnail-item-product';
const productImageWrappers = '.product__photo-wrapper-product';
const productThumbsWrapper = '.product-single__thumbnails-product';

switchProductImage = function(imageId) {
  $('.gallery__image.slick-slide').removeClass('slick-current slick-active').css(
    'opacity', '0');
  $('.gallery__image.slick-slide[data-image-id="' + imageId + '"]').addClass(
    'slick-current slick-active').css('opacity', '1');
}


callServer = function (callback,url,verb,parameters) {
  $.ajax({
    type: verb,
    url: url,
    data: parameters,//JSON.stringify(parameters),
    dataType: 'json',
    success: function(data) {
      callback(data);
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest);
      console.log(textStatus);
    }
  });
}

hintCallback = function (data) {
    //if (data.available) {
    $.magnificPopup.open({
      items: {
        src: $('#drop_hint_popup_success'),
      },
      type: 'inline',
      closeBtnInside:true
    });
}


//this isnt working currently
setActiveThumbnail = function(imageId) {
  var $thumbnailToShow = $(
    productThumbContainers +
    "[data-image-id='" +
    imageId +
    "']"
  );
  var $thumbnailsToHide = $(
    productThumbContainers +
    ":not([data-image-id='" +
    imageId +
    "'])"
  );
  $thumbnailsToHide.removeClass('is-active');
  $thumbnailToShow.addClass('is-active');

  var $thumbnails = $(productThumbsWrapper);

  // If there is a slick carousel, get the slide index, and position it into view with animation.
  if ($thumbnails.hasClass('slick-initialized')) {
    // eslint-disable-next-line shopify/jquery-dollar-sign-reference
    var currentActiveSlideIndex = $thumbnails.slick('slickCurrentSlide');
    var newActiveSlideIndex = parseInt(
      $thumbnailToShow.attr('data-slick-index')
    );
    if (currentActiveSlideIndex !== newActiveSlideIndex) {
      $thumbnails.slick('slickGoTo', newActiveSlideIndex, false);
    }
  }
}

hintButton = function(toemail,fromemail,toname,fromname,link,img) {
  callServer(hintCallback,'http://goldenbear.roswellstudios.com/hint',"POST",{toemail:toemail,fromemail:fromemail,toname:toname,fromname:fromname,link:link,img:img});
}
